import "./App.scss";
import { routes, coloredRoutes } from "./utils/RouteNames";
import React, { useContext, Suspense } from "react";
import { AuthContext } from "./contexts/AuthProvider";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Container, Loader } from "@nentech/charmanender-ui";
import dictionary from "./assets/dictionary.json";
import NavigationBar from "./components/ui/NavigationBar"
import desktopAsset from "./assets/logo-black.png";
import { signOut } from "./actions/auth";


const Home = React.lazy(() => import("./routes/Home"));
const Login = React.lazy(() => import("./routes/Login"));
const NotFound = React.lazy(() => import("./routes/NotFound"));
const InitialLoader = React.lazy(() => import("./routes/InitialLoader"));
const Error = React.lazy(() => import("./routes/Error"));
const RequestStatus = React.lazy(() => import("./routes/RequestStatus"));

function App() {
  const { session } = useContext(AuthContext) || {};
  const urlExists = routes.includes(useLocation().pathname);
  const isContainerColored = coloredRoutes.includes(useLocation().pathname);
  const profileData = localStorage.getItem("profileData");
  const normalizedProfileData = !!profileData
    ? JSON.parse(profileData)
    : undefined;

  const onClickLogout = async () => {
    try {
      await signOut();
    } catch (signOutException) {
      console.error("DEBUG:: signOutException", signOutException);
    }
  };

  return (
    <>
      {urlExists && (
        <NavigationBar
          profileData={normalizedProfileData}
          session={session}
          signedInPlaceholder={dictionary?.signInAs}
          logoutPlaceholder={dictionary?.logout}
          desktopAsset={desktopAsset}
          mobileAsset={desktopAsset}
          onClickLogout={onClickLogout}
        />
      )}
      <Container isColored={isContainerColored}>
        <Routes>

          {session === "loading" && (
            <>
              <Route
                path="/"
                element={
                  <Suspense fallback={<Loader />}>
                    <InitialLoader globalState={session} />
                  </Suspense>
                }
              />
              <Route path="/*" element={<Navigate replace to="/" />} />
            </>
          )}

          {session === "active" && (
            <>
              <Route path="/" element={<Navigate replace to="/home" />} />
              <Route path="/login" element={<Navigate replace to="/home" />} />
              
              <Route
                path="/home"
                element={
                  <Suspense fallback={<Loader />}>
                    <Home />
                  </Suspense>
                }
              />

              <Route
                path="/request-status"
                element={
                  <Suspense fallback={<Loader />}>
                    <RequestStatus />
                  </Suspense>
                }
              />

              <Route
                path="/error"
                element={
                  <Suspense fallback={<Loader />}>
                    <Error />
                  </Suspense>
                }
              />

              <Route
                path="/*"
                element={
                  <Suspense fallback={<Loader />}>
                    <NotFound />
                  </Suspense>
                }
              />
            </>
          )}
          
          {session === "inactive" && (
            <>
              <Route path="/" element={<Navigate replace to="/login" />} />
              <Route
                path="/login"
                element={
                  <Suspense fallback={<Loader />}>
                    <Login />
                  </Suspense>
                }
              />
              {routes.map((route, index) => {
                if (route !== "/login") {
                  return (
                    <Route
                      key={`${index}${route}${Math.random()}`}
                      path={route}
                      element={<Navigate replace to="/login" />}
                    />
                  );
                }
                return (
                  <React.Fragment key={`${index}${route}${Math.random()}`} />
                );
              })}
              <Route
                path="/*"
                element={
                  <Suspense fallback={<Loader />}>
                    <NotFound />
                  </Suspense>
                }
              />
            </>
          )}
        </Routes>
      </Container>
    </>
  );
}

export default App;
